import axios from "axios";
import { useState, useEffect } from "react";                  

/* ------------------------------------------------------------------ */
export default function DocumentationMaintenance({ onBack, onSelect, plantId, selected_plant_id }) {

    const org_id = localStorage.getItem("organization");
    const [plantCount, setPlantCount] = useState(0);

    useEffect(() => {
        // Check if we have multiple plants (from a plot)
        if (Array.isArray(selected_plant_id)) {
            setPlantCount(selected_plant_id.length);
            console.log(`Found ${selected_plant_id.length} plants for documentation`);
        }
    }, [selected_plant_id]);

    // helper – turns a File into a base-64 string
// helper – returns a Promise that resolves to a base-64 string
const fileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve(reader.result.replace(/^data:.*;base64,/, '')); // strip prefix
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const handleUpload = async () => {
    console.log('Selected plant ID:', selected_plant_id);
    try {
        const requestData = {
            notes: remark,
            plant_id: Array.isArray(selected_plant_id) ? selected_plant_id : [selected_plant_id]
        };

        if (picture) {
            const b64 = await fileToBase64(picture);
            requestData.image_base64 = b64;
        }

        await axios.post(
            `/orgs/${org_id}/maintenance/documentation`,
            requestData,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        alert('Upload complete');
        onBack && onBack(); // Return to previous screen after successful upload
    } catch (err) {
        console.error('Upload failed:', err);
        if (err.response?.status === 400) {
                alert('Upload failed - Check if all required fields are filled in correctly');
            } else if (err.response?.status === 401 || err.response?.status === 403) {
                alert("Upload failed - You are no longer logged in or you don't have access to this resource");
            } else if (err.response?.status === 500) {
                alert("Upload failed - Something went wrong in the service, please try again later");
            } else {
                alert(`Upload failed with error: ${err.response}`);
            }
    }
};

    
    const [remark, setRemark] = useState("");
    const [picture, setPicture] = useState(null);

return (
    <>
        <div className="maintenanceHeader">
            <h3>Documentation & Other</h3>
            <button className="uploadMaintenanceBtn" onClick={handleUpload}>Upload</button>
        </div>

        <div className="maintenaceGrid maintenanceList">
            <div className="dropdownBlock">
        <div className="purpleBtn extraGridBtn blueBtn" onClick={onBack}>
          Back
        </div>
        </div>
        </div>

        <div className="maintenaceGrid maintenanceList flexMaintenanceGrid" style={{ marginBottom: "20px" }}>
        {plantCount > 1 && (
            <div className="plotMaintenanceNotice">
                Applying documentation to all plants in plot ({plantCount} plants)
            </div>
        )}
        <table className="maintenanceTable">
            <tbody>
                <tr>
                    <td>Remarks/Notes</td>
                    <td>
                        <textarea
                            className="newMaintenanceInput"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <td>Picture</td>
                    <td>
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => setPicture(e.target.files[0])}
                        />
                    </td>
                </tr>
                {Array.isArray(selected_plant_id) && selected_plant_id.length > 1 && (
                    <tr>
                        <td>Plants affected</td>
                        <td>
                            <div className="plantCountLabel">
                                {selected_plant_id.length} plants in this plot
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
        </div>
    </>
)
}